// Vendor
import { Injectable } from "@angular/core";

// App
import { OrderSessionStorageService } from "./order-session-storage.service";
import { OrderMemoryStorageService } from "./order-memory-storage.service";
import { OrderLocalStorageService } from "./order-local-storage.service";

@Injectable({
    providedIn: "root",
})
export class OrderStorageService {
    constructor(
        public session: OrderSessionStorageService,
        public memory: OrderMemoryStorageService,
        public local: OrderLocalStorageService
    ) {}
}
